import { useUser } from '@gik/api/users/user';
import { useUserStore } from '@gik/core/store/UserStore';
import bemBlock from '@gik/core/utils/bemBlock';
import type { IAvatarProps } from '@gik/ui/Avatar';
import { Avatar } from '@gik/ui/Avatar';
import React from 'react';

export interface IUserAvatarProps extends IAvatarProps {}

/**
 * Displays the avatar of the currently logged in user.
 */
export function UserAvatar({ className, ...otherProps }: IUserAvatarProps): React.ReactElement {
  const bem = bemBlock('user-avatar');

  const userStore = useUserStore();
  const { data: user, isValidating } = useUser(userStore.id);

  return (
    <Avatar
      loading={isValidating}
      imageUrl={user?.avatarThumbSmallURL}
      className={bem(null, null, className)}
      {...otherProps}
    />
  );
}
